<script>
  import Vue from 'vue';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import DadosSolicitacao from './compartilhado/FormDadosSolicitacao.vue';
  import DadosProforma from './compartilhado/FormDadosProforma.vue';
  import AdicionarItem from './compartilhado/FormAdicionarItem.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import ListaItem from './compartilhado/FormListaItens.vue';
  import VueSweetAlert from 'vue-sweetalert';
  import solicitacaoImportacaoServico from '../servico';

  Vue.use(VueSweetAlert);

  export default {
    components: { DadosSolicitacao, DadosProforma, AdicionarItem, ListaItem, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        solicitacao: {
          idProjeto: '',
          idMoeda: '',
          estado: '',
          observacaoSolicitacao: '',
          itensSolicitacaoImportacao: [],
          cotacaoEstimada: 1.0,
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
          },
          importacaoMoeda: {
            idImportacaoMoeda: null,
            simbolo: null,
            nomeMoeda: null,
          }
        },
        carregando: false,
        arquivos: [],
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Importação - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-importacao-projeto.nova';

      this.$events.emit('carregarMoedas');
      this.$events.emit('carregarFormaPagamentos');
      this.$events.emit('carregarIncoterm');
      this.$events.emit('carregarPrevisaoEntregas');
      this.$events.emit('carregarTipoEmbarque');
      this.$events.emit('carregarDestinoCarga');
      this.$events.emit('carregarBancos');

      this.mostrarInstrucoes();
    },
    created() {
      if (this.$route.params.id) {
        this.carregar(this.$route.params.id);
      }
    },
    methods: {
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosSolicitacao
          .validarDadosSolicitacao()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-solicitacao"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosProforma.validarDadosSolicitacao)
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-dados-proforma"]').tab('show');
                throw new Error("validacao");
              }

              return valido;
            })
          .then(this.validarSePossuiItens)
          .then(this.concatenarLocalEntrega)
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-importacao-projeto.relatorio', id, 'solicitacao-importacao-projeto');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      validarSePossuiItens(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        if (this.solicitacao.itensSolicitacaoImportacao.length > 0) return true;

        $('#tabs a[href="#tab-adicionar-itens"]').tab('show');
        
        this.$swal(
          '',
          'A solicitação deve possuir ao menos um item.',
          'info'
        );

        throw new Error("validacao");
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        
        if (this.$route.params.id) {
          return solicitacaoImportacaoServico.alterar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoImportacaoServico.adicionar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos);
        }
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolImportacao || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolImportacao.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      concatenarLocalEntrega(valido) {
        this.solicitacao.localEntrega = [
          this.solicitacao.endereco,
          this.solicitacao.bairro,
          this.solicitacao.cidade,
          this.solicitacao.estado,
          this.solicitacao.cep || '',
        ].join('=|=');
        
        return valido;
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;

        solicitacaoImportacaoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
          })
          .then(() => solicitacaoImportacaoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.$set(this.solicitacao, 'numeroLocalAlocado', solicitacao.numeroLocalAlocado);
            this.$set(this.solicitacao, 'complementoLocalAlocado', solicitacao.complementoLocalAlocado);
            
            this.carregando = false;
          });
      },
      download(arquivo) {
        solicitacaoImportacaoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      nl2br(str) {
        var breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },
      editarItem(indice) {
        if (this.$refs.adicionarItem) {
            this.$refs.adicionarItem.editarItem(this.solicitacao.itensSolicitacaoImportacao[indice], indice);
            $('#tabs a[href="#tab-adicionar-itens"]').tab('show');
        }
      }
    },
    beforeDestroy() {
      this.$events.off('carregarMoedas');
      this.$events.off('carregarFormaPagamentos');
      this.$events.off('carregarIncoterm');
      this.$events.off('carregarPrevisaoEntregas');
      this.$events.off('carregarTipoEmbarque');
      this.$events.off('carregarDestinoCarga');
      this.$events.off('carregarBancos');
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form>

      <div class="row">
          <div class="col-xs-12">
              <div class="ibox float-e-margins" v-if="carregando">
                  <div class="ibox-content">
                      <p class="text-center">
                          <i class='fa fa-spinner fa-pulse'></i> Carregando...
                      </p>
                  </div>
              </div>

              <div class="alert alert-warning" role="alert" v-show="solicitacao.observacaoCancelamento">
                  <div class="row">
                      <div class="col-xs-12">
                          <div class="form-group no-margins">
                              <dl class="col-xs-12">
                                  <dt>Observação cancelamento</dt>
                                  <dd v-html="nl2br(solicitacao.observacaoCancelamento)">
                                      {{ nl2br(solicitacao.observacaoCancelamento) }}
                                  </dd>
                              </dl>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="tabs-container" v-show="!carregando" id="tabs">

                  <ul class="nav nav-tabs">
                      <li class="active">
                          <a data-toggle="tab"
                             href="#tab-dados-solicitacao">
                              Processo
                          </a>
                      </li>
                      <li>
                          <a data-toggle="tab"
                             href="#tab-dados-proforma">
                              Proforma invoice
                          </a>
                      </li>
                      <li>
                          <a data-toggle="tab"
                             href="#tab-adicionar-itens">
                              Adicionar itens
                          </a>
                      </li>
                      <li>
                          <a data-toggle="tab"
                             href="#tab-itens-solicitacao">
                              Itens da solicitação
                          </a>
                      </li>
                      <li v-if="configuracao.usarArquivosSolicitacaoImportacao">
                          <a data-toggle="tab"
                             href="#tab-adicionar-arquivos">
                              Adicionar arquivos
                          </a>
                      </li>
                      <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoImportacao">
                          <a data-toggle="tab"
                             href="#tab-lista-arquivos">
                              Arquivos
                          </a>
                      </li>
                  </ul>
                  <div class="tab-content">

                      <div id="tab-dados-solicitacao" class="tab-pane active">
                          <div class="panel-body">
                              <dados-solicitacao ref="dadosSolicitacao"
                                                 :solicitacao.sync="solicitacao"
                                                 :carregando="carregando"
                                                 :edicao="!!$route.params.id">
                              </dados-solicitacao>
                          </div>
                      </div>
                      <div id="tab-dados-proforma" class="tab-pane">
                          <div class="panel-body">
                              <dados-proforma ref="dadosProforma"
                                              :solicitacao.sync="solicitacao"
                                              :carregando="carregando"
                                              :edicao="!!$route.params.id">
                              </dados-proforma>
                          </div>
                      </div>
                      <div id="tab-adicionar-itens" class="tab-pane">
                          <div class="panel-body">
                              <adicionar-item :itens-solicitacao-importacao.sync="solicitacao.itensSolicitacaoImportacao"
                                              :solicitacao.sync="solicitacao"
                                              ref="adicionarItem">
                              </adicionar-item>
                          </div>
                      </div>
                      <div id="tab-itens-solicitacao" class="tab-pane">
                          <div class="panel-body">
                              <lista-item :itens-solicitacao-importacao.sync="solicitacao.itensSolicitacaoImportacao"
                                          :solicitacao.sync="solicitacao"
                                          @editarItem="editarItem">
                              </lista-item>
                          </div>
                      </div>
                      <div id="tab-adicionar-arquivos" class="tab-pane">
                          <div class="panel-body">
                              <adicionar-arquivos ref="adicionarArquivos">
                              </adicionar-arquivos>
                          </div>
                      </div>
                      <div id="tab-lista-arquivos" class="tab-pane">
                          <div class="panel-body">
                              <lista-de-arquivos :arquivos="arquivos"
                                                 @download="download"
                                                 ref="listaArquivos">
                              </lista-de-arquivos>
                          </div>
                      </div>

                  </div>

              </div>
          </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default" :to="{ name: 'solicitacao-importacao-projeto' }" active-class="">
              <i class="fa fa-arrow-left"></i> 
              Voltar
            </router-link>

            <button
                id="salvar"
                type="button" 
                class="btn btn-primary" 
                @click="salvar"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i> 
              Salvar
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao-projeto/componentes/SolicitacaoImportacaoForm.vue